import { Component, inject, OnInit } from '@angular/core';
import {
  DxTemplateDirective,
  DxLoadPanelComponent,
  DxButtonComponent,
  DxDataGridComponent,
} from 'devextreme-angular';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { CategorieArticoliService } from 'src/app/shared/services/categorie-articoli.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import notify from 'devextreme/ui/notify';
import { CategorieArticoli } from 'src/app/models/categorieArticoli';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { RiepilogoRiordinoService } from 'src/app/shared/services/riepilogo-riordino.service';
import {
  RiepilogoRiordino,
  RiepilogoRiordinoFisso,
} from 'src/app/models/riepilogo-riordino';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { ModuloRiordinoComponent } from 'src/app/shared/components/modulo-riordino/modulo-riordino.component';
import { ProposteGestioneService } from 'src/app/shared/services/proposte-gestione.service';
import { Router } from '@angular/router';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { Articoli } from 'src/app/models/articoli';
import { Dipendente } from 'src/app/models/dipendente';
import {
  DxiColumnComponent,
  DxoColumnChooserComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoGroupingComponent,
  DxoGroupPanelComponent,
  DxoHeaderFilterComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoSearchPanelComponent,
  DxoSelectionComponent,
  DxoSortingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';

@Component({
  selector: 'app-calcolo-riepilogo-riordino',
  templateUrl: './calcolo-riepilogo-riordino.component.html',
  styleUrls: ['./calcolo-riepilogo-riordino.component.css'],
  imports: [
    DxTemplateDirective,
    DxLoadPanelComponent,
    DxButtonComponent,
    DxDataGridComponent,
    ModuloRiordinoComponent,
    DxoGroupPanelComponent,
    DxoGroupingComponent,
    DxoSearchPanelComponent,
    DxoSortingComponent,
    DxoColumnChooserComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoExportComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxiColumnComponent,
    DxoLookupComponent,
    DxoTextsComponent,
    DxoSelectionComponent,
    DxoEditingComponent,
  ],
  standalone: true,
})
export class CalcoloRiepilogoRiordinoComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private catService = inject(CategorieArticoliService);
  private tipiService = inject(TipiArticoliService);
  private dipService = inject(DipendentiService);
  private riepilogService = inject(RiepilogoRiordinoService);
  private propService = inject(ProposteGestioneService);
  private artService = inject(ArticoliService);
  private router = inject(Router);
  visibleLoadPanel = false;
  //listResponsabili: Responsabile[];
  //listMansioni: Mansioni[];
  listCategorie: CategorieArticoli[] = [];
  listTipiArticoliTutti: TipiArticoli[];
  listTipiArticoli: TipiArticoli[] = [];
  //listSiti: Siti[];
  //listRepartiTutti: Reparti[];
  //listReparti: Reparti[];
  listArticoli: Articoli[] = [];
  listDipendenti: Dipendente[] = [];

  //idCategoriaFilter = 0;
  //idTipologiaFilter = 0;
  //idSitoFilter = 0;
  //idRepartoFilter = 0;
  //idResponsabileFilter = 0;
  //idMansioneFilter = 0;

  listDettaglioCorrente: any[];
  listRiepilogoRiordino: RiepilogoRiordino[];
  riepilogoRiordinoFisso: RiepilogoRiordinoFisso;
  listTipoProposta = JSON.parse(
    '[{"codice":"C", "descrizione":"Consegna"},{"codice":"R", "descrizione":"Ritiro"}, {"codice":"P", "descrizione":"Articolo Previsto"}, {"codice":"N", "descrizione":"Nuovo Articolo"} , {"codice":"O", "descrizione":"Articolo Obsoleto"},{"codice":"D", "descrizione":"Agg. dipendente"},{"codice":"I", "descrizione":"Import dispenser"}]',
  );

  ngOnInit() {
    this.loadLookups();
  }

  loadLookups() {
    this.artService.listTemp().subscribe({
      next: (dati) => {
        this.listArticoli = dati.filter(x => x.attivo == true);
      }
    });

    this.dipService.listTemp().subscribe({
      next: (dati) => {
        this.listDipendenti = dati;
      }
    });
    /*
    this.dipService.listResponsabili().subscribe((dati) => 
      {
        this.listResponsabili = dati;
      },
      async error => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, "warning");
        } else {
          notify("Errore caricamento responsabili", "warning");
        };
      });  

    this.manService.list().subscribe((dati) => 
      {
        this.listMansioni = dati;
      },
      async error => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, "warning");
        } else {
          notify("Errore caricamento mansioni", "warning");
        };
      });
*/
    this.catService.listTemp().subscribe({
      next: (dati) => {
        this.listCategorie = dati;
      }
    });

    this.tipiService.getListTipiArticoliTemp().subscribe({
      next: (dati) => {
        this.listTipiArticoli = dati;
        this.listTipiArticoliTutti = dati;
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento tipi articoli', 'warning');
        }
      },
    });
    /*
    this.sitiService.list().subscribe((dati) => 
      {
        this.listSiti = dati;
      },
      async error => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, "warning");
        } else {
          notify("Errore caricamento siti", "warning");
        };
      });

    this.repService.list().subscribe((dati) => 
      {
        this.listReparti = dati;
        this.listRepartiTutti = dati;
      },
      async error => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, "warning");
        } else {
          notify("Errore caricamento reparti", "warning");
        };
      });
      */
  }
  /*
  onCategoriaSelected(e){
    if (this.idCategoriaFilter){
      this.listTipiArticoli = this.listTipiArticoliTutti.filter(t => t.idCategoria == this.idCategoriaFilter);
      if (this.idTipologiaFilter > 0 && !this.listTipiArticoli.find(t => t.id == this.idTipologiaFilter)){
        this.idTipologiaFilter = 0;
      }
    }else{
      this.listTipiArticoli = this.listTipiArticoliTutti;
    }
  }

  onTipologiaSelected(e){

  }

  onSitoSelected(e){
    if (this.idSitoFilter){
      this.listReparti = this.listRepartiTutti.filter(t => t.idSito == this.idSitoFilter);
      if (this.idTipologiaFilter > 0 && !this.listTipiArticoli.find(t => t.id == this.idTipologiaFilter)){
        this.idTipologiaFilter = 0;
      }
    }else{
      this.listReparti = this.listRepartiTutti;
    }
  }

  onRepartoSelected(e){

  }

  onResponsabileSelected(e){

  }

  onMansioneSelected(e){

  }
  */

  onBtnCaricaCalcoliClick() {
    /*this.riepilogService.getDettaglioCorrente(this.idCategoriaFilter, this.idTipologiaFilter, this.idSitoFilter, this.idRepartoFilter, this.idResponsabileFilter, this.idMansioneFilter).subscribe((dati) => 
      {
        this.listDettaglioCorrente = dati;
      },
      async error => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, "warning");
        } else {
          notify("Errore caricamento dettaglio corrente", "warning");
        };
      });
    
    let annoCorr = new Date().getFullYear();
    this.riepilogService.getRiepilogoAnnuale(annoCorr, this.idCategoriaFilter, this.idTipologiaFilter, this.idSitoFilter, this.idRepartoFilter, this.idResponsabileFilter, this.idMansioneFilter, true).subscribe((dati) => 
      {
        this.listRiepilogoRiordino = dati;
      },
      async error => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, "warning");
        } else {
          notify("Errore caricamento riepilogo riordino", "warning");
        };
      });*/
    const annoCorr = new Date().getFullYear();
    this.riepilogService.getRiepilogoFisso(annoCorr).subscribe({
      next: (dati) => {
        this.riepilogoRiordinoFisso = dati;
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento riepilogo riordino fisso', 'warning');
        }
      },
    });
  }

  //ESPORTAZIONE IN EXCEL
  onExportingGridAssegnazioni(e: any) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Assegnazioni');
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer: any) => {
        saveAs(
          new Blob([buffer], { type: 'application/octet-stream' }),
          'Assegnazioni corrente.xlsx',
        );
      });
    });
    e.cancel = true;
  }
  onExportingGridRiepilogo(e: any) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Riepilogo');
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer: any) => {
        saveAs(
          new Blob([buffer], { type: 'application/octet-stream' }),
          'Riepilogo riordino.xlsx',
        );
      });
    });
    e.cancel = true;
  }

  onCellRiepilogoPrepared(e: any) {
    if (
      e.rowType == 'data' &&
      e.column.name === 'giacenza' &&
      e.data.articolo.giacenza < e.data.articolo.scortaMinima
    ) {
      e.cellElement.style.color = 'white';
      e.cellElement.style.backgroundColor = 'darkred';
    }
  }

  customizeTextGiacenza(e: any) {
    if (e.value == null) {
      return '0';
    }
    return e.value.toString();
  }

  calculateCellValueGiacenza(rowData: any) {
    if (rowData.articolo?.giacenza == null) {
      return 0;
    }
    return rowData.articolo?.giacenza;
  }

  doAggiornaModello(rowData: any) {
    rowData.visto = true;
    this.visibleLoadPanel = true;
    this.propService.update(rowData.id, rowData).subscribe({
      next: () => {
        this.visibleLoadPanel = false;
        const url = this.router.serializeUrl(
          this.router.createUrlTree([
            '/dipendenti/detail/' +
              rowData.idDipendente +
              '/dettaglio-articoli',
          ]),
        );
        window.open(url, '_blank');
      },
      error: (error) => {
        this.visibleLoadPanel = false;
        console.error('Errore gestione proposta: ' + error);
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore gestione proposta', 'warning');
        }
      },
    });
  }

  getArticoloDisplayExpr(item: Articoli) {
    if (!item) {
      return '';
    }

    return item.codice + ' - ' + item.descrizione;
  }

  getDipendenteDisplayExpr(item: Dipendente) {
    if (!item) {
      return '';
    }

    return item.codice + ' - ' + item.nominativo;
  }
}
